var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58366 5.24984H6.41699V4.08317H7.58366M7.58366 9.9165H6.41699V6.4165H7.58366M7.00033 1.1665C6.23428 1.1665 5.47574 1.31739 4.76801 1.61054C4.06027 1.90369 3.41721 2.33337 2.87554 2.87505C1.78157 3.96901 1.16699 5.45274 1.16699 6.99984C1.16699 8.54693 1.78157 10.0307 2.87554 11.1246C3.41721 11.6663 4.06027 12.096 4.76801 12.3891C5.47574 12.6823 6.23428 12.8332 7.00033 12.8332C8.54742 12.8332 10.0312 12.2186 11.1251 11.1246C12.2191 10.0307 12.8337 8.54693 12.8337 6.99984C12.8337 6.23379 12.6828 5.47525 12.3896 4.76752C12.0965 4.05978 11.6668 3.41672 11.1251 2.87505C10.5834 2.33337 9.94038 1.90369 9.23265 1.61054C8.52491 1.31739 7.76637 1.1665 7.00033 1.1665Z",
    fill: "#00aa8f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.0ef3925186feaae44359ce520a6b8a96.svg";
export { ForwardRef as ReactComponent };